import { AsyncValidatorFn, ValidatorFn } from '@angular/forms';
import { EditorColumnConfig } from './editor-column-config.model';
import { EditorItemConfig } from './editor-item-type';

export interface EditorConfig {
  items: EditorItemConfig[] | EditorColumnConfig[];
  readonly?: boolean;
  groupValidators?: ValidatorFn | ValidatorFn[] | null;
  groupAsyncValidators?: AsyncValidatorFn[];
  showDebug?: boolean;
  clearFormBtn?: boolean;
}
